export default {
    dependencies: ['$element', '$controllerator', 'radio', 'templateservice'],
    callable(formEle, controllerator, radio, templateservice) {
        let contextSpecificFilterNames = [
            ...formEle.querySelectorAll('[data-context-specific-filter]'),
        ].map(ele => ele.id);
        const loadingAnimation = formEle.querySelector(
            '[data-loading-animation]'
        );

        radio('filter-and-search-changed').subscribe(updateWidgets);
        radio('searchFilter.notChanged').subscribe(() =>
            toggleLoadingAnimation(false)
        );
        radio('filter.query-changed').subscribe(() =>
            toggleLoadingAnimation(true)
        );

        const lockingFilters = ['category', 'sub_category', 'product_category'];
        formEle.addEventListener('change', event => {
            if (lockingFilters.find(filter => filter === event.target.name)) {
                toggleLoadingAnimation(true);
            }
        });

        function toggleLoadingAnimation(show) {
            if (loadingAnimation) {
                // can happen if this is a legacy search and the TaxonomyTreeWidget is missing on the rendered page
                loadingAnimation.classList.toggle('hidden', !show);
            }
        }

        function updateWidgets(result) {
            if (result.filterWidgets.length < 5) {
                console.error('Response is missing filters');
                return; // too few filters returned
            }

            result.filterWidgets.forEach((filter, index) => {
                if (
                    (filter.categorySpecificTaxonomyWidget ||
                        filter.categorySpecificRangeWidget) &&
                    !contextSpecificFilterNames.some(
                        filterName => filterName === `filter_${filter.name}`
                    )
                ) {
                    createWidgetEle(filter, index);
                }
            });

            const contextSpecificWidgetResults = result.filterWidgets.filter(
                filterWidget =>
                    filterWidget.categorySpecificTaxonomyWidget ||
                    filterWidget.categorySpecificRangeWidget
            );
            contextSpecificFilterNames.forEach(filterName => {
                if (
                    !contextSpecificWidgetResults.some(
                        filter => filterName === `filter_${filter.name}`
                    )
                ) {
                    removeFilter(filterName);
                }
            });
            contextSpecificFilterNames = contextSpecificWidgetResults.map(
                f => `filter_${f.name}`
            );

            toggleLoadingAnimation(false);
        }

        function removeFilter(filterName) {
            document.getElementById(filterName).remove();
        }

        function createWidgetEle(filter, index) {
            const widgetEle = asNodeEle(
                templateservice.render('filter_overlay', filter)
            );
            formEle.children[index].after(widgetEle);
            controllerator.run();
        }

        function asNodeEle(html) {
            const template = document.createElement('div');
            template.innerHTML = html;
            return template.firstElementChild;
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/contextSpecificFilters.js